import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "",
    name: "home",
    component: () => import("@/modules/home/views/HomeView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
